import { render, staticRenderFns } from "./tck-ziyuan219.vue?vue&type=template&id=39f9da7d&"
import script from "./tck-ziyuan219.vue?vue&type=script&lang=js&"
export * from "./tck-ziyuan219.vue?vue&type=script&lang=js&"
import style0 from "./tck-ziyuan219.vue?vue&type=style&index=0&id=39f9da7d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports